export const translations = {
  en: {
    welcomeMessage: "PickStar",
    askPlaceholder: "Ask me...",
    upgradePrompt: "Unlock Unlimited Premium Features with PickStar Pro",
    footer: {
      privacyPolicy: "Privacy Policy",
      terms: "Terms & Conditions",
      rights: "All rights reserved."
    },
    chat: {
      messageLimit: "Messages remaining today",
      loading: "AI is thinking...",
      networkError: "Network Error: Please try again later",
      upgrade: {
        title: "Message Limit Reached",
        description: "You've reached your daily message limit.",
        resetTime: "Messages will reset in {hours} hours.",
        button: "Upgrade to Pro",
        proFeatures: "Pro features coming soon!"
      }
    },
    navigation: {
      home: "Home",
      community: "Community",
      settings: "Settings",
      upgrade: "Upgrade",
      help: "Help",
      profile: "Profile",
      signOut: "Sign Out",
      confirmLogout: "Are you sure you want to log out?"
    }
  },
  es: {
    welcomeMessage: "Bienvenido a PickStar",
    askPlaceholder: "Pregúntame...",
    upgradePrompt: "Desbloquea funciones premium ilimitadas con PickStar Pro",
    footer: {
      privacyPolicy: "Política de Privacidad",
      terms: "Términos y Condiciones",
      rights: "Todos los derechos reservados."
    },
    chat: {
      messageLimit: "Mensajes restantes hoy",
      loading: "La IA está pensando...",
      networkError: "Error de red: Inténtalo de nuevo más tarde",
      upgrade: {
        title: "Límite de mensajes alcanzado",
        description: "Has alcanzado tu límite diario de mensajes.",
        resetTime: "Los mensajes se reiniciarán en {hours} horas.",
        button: "Actualizar a Pro",
        proFeatures: "¡Características Pro próximamente!"
      }
    },
    navigation: {
      home: "Inicio",
      community: "Comunidad",
      settings: "Configuración",
      upgrade: "Mejorar",
      help: "Ayuda",
      profile: "Perfil",
      signOut: "Cerrar Sesión"
    }
  },
  pt: {
    welcomeMessage: "Bem-vindo ao PickStar",
    askPlaceholder: "Pergunte-me...",
    upgradePrompt: "Desbloqueie recursos premium ilimitados com PickStar Pro",
    footer: {
      privacyPolicy: "Política de Privacidade",
      terms: "Termos e Condições",
      rights: "Todos os direitos reservados."
    },
    chat: {
      messageLimit: "Mensagens restantes hoje",
      loading: "A IA está pensando...",
      networkError: "Erro de rede: Tente novamente mais tarde",
      upgrade: {
        title: "Limite de mensagens atingido",
        description: "Você atingiu seu limite diário de mensagens.",
        resetTime: "As mensagens serão redefinidas em {hours} horas.",
        button: "Atualizar para Pro",
        proFeatures: "Recursos Pro em breve!"
      }
    },
    navigation: {
      home: "Início",
      community: "Comunidade",
      settings: "Configurações",
      upgrade: "Atualizar",
      help: "Ajuda",
      profile: "Perfil",
      signOut: "Sair"
    }
  }
};


// export const translations = {
//     en: {
//       welcomeMessage: "PickStar",
//       askPlaceholder: "Ask me...",
//       upgradePrompt: "Unlock Unlimited Premium Features with PickStar Pro",
//       footer: {
//         privacyPolicy: "Privacy Policy",
//         terms: "Terms & Conditions",
//         rights: "All rights reserved."
//       },
//       chat: {
//         messageLimit: "Messages remaining today",
//         loading: "AI is thinking...",
//         networkError: "Network Error: Please try again later",
//         upgrade: {
//           title: "Message Limit Reached",
//           description: "You've reached your daily message limit.",
//           resetTime: "Messages will reset in {hours} hours.",
//           button: "Upgrade to Pro",
//           proFeatures: "Pro features coming soon!"
//         }
//       }
//     },
//     es: {
//       welcomeMessage: "Bienvenido a PickStar",
//       askPlaceholder: "Pregúntame...",
//       upgradePrompt: "Desbloquea funciones premium ilimitadas con PickStar Pro",
//       footer: {
//         privacyPolicy: "Política de Privacidad",
//         terms: "Términos y Condiciones",
//         rights: "Todos los derechos reservados."
//       },
//       chat: {
//         messageLimit: "Mensajes restantes hoy",
//         loading: "La IA está pensando...",
//         networkError: "Error de red: Inténtalo de nuevo más tarde",
//         upgrade: {
//           title: "Límite de mensajes alcanzado",
//           description: "Has alcanzado tu límite diario de mensajes.",
//           resetTime: "Los mensajes se reiniciarán en {hours} horas.",
//           button: "Actualizar a Pro",
//           proFeatures: "¡Características Pro próximamente!"
//         }
//       }
//     },
//     pt: {
//       welcomeMessage: "Bem-vindo ao PickStar",
//       askPlaceholder: "Pergunte-me...",
//       upgradePrompt: "Desbloqueie recursos premium ilimitados com PickStar Pro",
//       footer: {
//         privacyPolicy: "Política de Privacidade",
//         terms: "Termos e Condições",
//         rights: "Todos os direitos reservados."
//       },
//       chat: {
//         messageLimit: "Mensagens restantes hoje",
//         loading: "A IA está pensando...",
//         networkError: "Erro de rede: Tente novamente mais tarde",
//         upgrade: {
//           title: "Limite de mensagens atingido",
//           description: "Você atingiu seu limite diário de mensagens.",
//           resetTime: "As mensagens serão redefinidas em {hours} horas.",
//           button: "Atualizar para Pro",
//           proFeatures: "Recursos Pro em breve!"
//         }
//       }
//     }
//   };